import { deleteImageFromIndexedDB } from './deleteImageFromIndexedDB'
import { getPendingUploads } from './getPendingUploads'
import { savePendingUploads } from './savePendingUploads'

export async function deletePendingUpload(pendingUploadId: string) {
  const pendingUploads = getPendingUploads()

  const pendingToRemove = pendingUploads.find(item => item.pendingUploadId === pendingUploadId)

  if (!pendingToRemove) {
    throw Error('Upload pendente não encontrado')
  }

  await Promise.all(
    pendingToRemove.imagesList.map(async (img) => {
      await deleteImageFromIndexedDB(img.indexedDBImageId!)
    }),
  )

  const newPendingUploads = pendingUploads.filter(item => item.pendingUploadId !== pendingToRemove.pendingUploadId)

  savePendingUploads(newPendingUploads)
}
